import SideBarLayout from "../../../global/layout/SideBarLayout";

type RenderContainerProps = {
    type?: 'list' | 'default';
    children: React.ReactNode;
};

const RenderContainer = ({ type = 'default', children }: RenderContainerProps) => {
    const content = (
        <div id="scrollableId" className="ua-page">
            {children}
        </div>
    );

    if (type === 'list') {
        return (
            <SideBarLayout>
                <div className="right-content-full-screen">
                    {content}
                </div>
            </SideBarLayout>
        );
    }

    return content;
};

export default RenderContainer